export const pagesWithProgressBar: string[] = [
  '/f1',
  '/q2',
  '/q3',
  '/f2',
  '/q4',
  '/q5',
  '/f3',
  '/q6',
  '/q7',
  '/q8',
  '/q9',
  '/q10',
  '/f4',
  '/q11',
  '/q12',
  '/q13',
  '/q14',
  '/q15',
  '/q16',
  '/q17',
  '/age',
  '/quiz-results',
  '/q18',
  '/f5',
  '/signup',
  '/f6',
  '/name',
  '/f7',
  '__last_hidden',
];
